export default __webpack_public_path__ + "static/retail-theater-ae416e8a7a7985b28d0e88cb23dd1d41.gif";